import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, fetchSignInMethodsForEmail } from 'firebase/auth';

const Recuperar = () => {
  const [email, setEmail] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [cargando, setCargando] = useState(false);
  const navigate = useNavigate();
  const auth = getAuth();

  const handleEnviarCodigo = async (e) => {
    e.preventDefault();
    setMensaje('');
    setCargando(true);

    try {
      const methods = await fetchSignInMethodsForEmail(auth, email);

      // Si el usuario solo tiene Google
      if (methods.includes('google.com') && !methods.includes('password')) {
        setMensaje(
          'Tu cuenta está asociada a Google. Inicia sesión seleccionando tu cuenta de Google.'
        );
        setCargando(false);
        return;
      }

      await fetch("https://us-central1-ekineapp.cloudfunctions.net/sendRecoveryCode", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ data: { email } }),
      });

      localStorage.setItem('recoveryEmail', email);
      navigate('/verificar-codigo');

    } catch (error) {
      console.error('❌ Error al enviar el código:', error);
      setMensaje('Error al enviar el código. Verifica tu correo.');
    } finally {
      setCargando(false);
    }
  };

  return (
    <div
      className="min-h-screen flex justify-center items-center px-4"
      style={{
        background: "linear-gradient(to bottom right, #EAF6FF, #DCEFFF, #F8FAFC)",
      }}
    >
      <div className="w-full max-w-md bg-white/60 backdrop-blur-xl rounded-3xl 
                      shadow-[0_18px_50px_-15px_rgba(58,106,255,0.35)]
                      ring-1 ring-blue-100 p-8">

        <h1 className="text-3xl md:text-4xl font-extrabold text-blue-900 text-center mb-6">
          Recuperar Contraseña
        </h1>

        <form onSubmit={handleEnviarCodigo} className="space-y-5">

          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Correo electrónico"
            className="w-full border border-blue-100 rounded-xl px-4 py-3 bg-white/90
                       focus:outline-none focus:ring-2 focus:ring-[#3A6AFF]"
            required
          />

          <button
            type="submit"
            disabled={cargando}
            className={`w-full py-3 rounded-xl font-semibold text-white transition
                       ${cargando ? "bg-blue-400" : "bg-[#3A6AFF] hover:bg-blue-700"}`}
          >
            {cargando ? 'Enviando...' : 'Enviar código'}
          </button>
        </form>

        {mensaje && (
          <p className="text-center text-sm mt-4 text-gray-700">{mensaje}</p>
        )}

        <p className="text-center text-sm mt-6">
          ¿Ya tienes tu código?{' '}
          <button
            onClick={() => navigate('/verificar-codigo')}
            className="text-blue-600 hover:underline font-medium"
          >
            Ingrésalo aquí
          </button>
        </p>
      </div>
    </div>
  );
};

export default Recuperar;
